<template>
	<div>
		<p v-if="deliveryAddress">
			<template v-if="deliveryAddress.deliveryAddressNameLine1">
				{{ deliveryAddress.deliveryAddressNameLine1 }}<br />
			</template>
			<template v-if="deliveryAddress.street">
				{{ deliveryAddress.street }}<br />
			</template>
			<template v-if="deliveryAddress.postalCode || deliveryAddress.city">
				{{ deliveryAddress.postalCode }} {{ deliveryAddress.city }}<br />
			</template>
			<template v-if="deliveryAddress.countryCode">
				{{ deliveryAddress.countryCode }}
			</template>
		</p>

		<slot v-else name="noDeliveryAddress"></slot>

		<slot name="button"></slot>
	</div>
</template>

<script lang="ts" setup>
	import type {DeliveryAddress} from 'dummen-shared';

	defineProps<{
		deliveryAddress: DeliveryAddress | null;
	}>();
</script>
